aws_amplify.Amplify.configure({
  Auth: {
      region: 'eu-west-1',
      userPoolId: 'eu-west-1_KdJHIg7PB',
      userPoolWebClientId: 'p5l9tsg2t7m0nlqmt4d8mmffn',
      authenticationFlowType: "USER_PASSWORD_AUTH",
      oauth: {
        scope: ['email', 'openid', 'profile'],
        redirectSignIn: 'https://gwrsandbox.gwrstore.com/success',
        redirectSignOut: 'https://gwrsandbox.gwrstore.com/success',
        responseType: 'code',
      }
    }
});

console.log('aws_amplify configured successfully!');
